import { ServicePagination } from "~/api";

export const mapLaravelPagination = (
  meta: {
    current_page: number;
    per_page: number;
    last_page: number;
    total: number;
  },
  links: {
    next: string | null;
    prev: string | null;
  },
): ServicePagination => ({
  currentPage: meta.current_page,
  perPage: meta.per_page,
  totalPages: meta.last_page,
  total: meta.total,
  count: meta.total,
  links: {
    next: links.next ?? "",
    previous: links.prev ?? "",
  },
});
